<template>
  <div class="quality-inspection-pc">
    <div class="machine-type">
      <div class="panel" @click="intoSwanQualityInspection">天鹅</div>
    </div>
    <product-info feedbackType="日常质检"></product-info>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useRoute, useRouter } from "vue-router";
import productInfo from "@/views/productDaily/pc/info/index.vue";
import feedbackVue from "../components/feedback/index.vue";
import responsibilityVue from "../components/responsibility.vue";

export default defineComponent({
  components: { responsibilityVue, feedbackVue, productInfo },
  setup() {
    const router = useRouter();

    const route = useRoute();

    const intoSwanQualityInspection = () => {
      router.push({
        path: "/swanqualityinspection",
        query: {
          meta: encodeURI(JSON.stringify(route.meta)),
        },
      });
    };

    return {
      intoSwanQualityInspection,
    };
  },
});
</script>

<style lang="less" scoped>
.quality-inspection-pc {
  width: 100%;
  height: calc(100vh - 120px);
  background: #fff;
  box-shadow: 0 0 10px 0 #ccc;
  border-radius: 20px;
  padding: 10px;
  position: relative;
  .machine-type {
    cursor: pointer;
    position: absolute;
    background: #fff;
    right: 10px;
    top: 10px;
    z-index: 9;
    .panel {
      width: 100px;
      height: 100px;
      font-size: 30px;
      text-align: center;
      line-height: 100px;
      box-shadow: 0 0 10px 0 #ccc;
      border-radius: 20px;
    }
  }
}
</style>
